<app-state-section [state]="offset ? SectionStateStatus.Ready : sectionState">
  <div class="flex align-center row search" [class.search__relative]="!searchToogle">
    <app-icon
      class="icon icon--xsmall align-center d-inline d-none-md search__icon text-primary"
      name="search"
      (click)="searchToogle = !searchToogle"
      *ngIf="!searchToogle"
      size="xs"
    ></app-icon>
    <div
      class="search__input d-none d-block-md bg-default-lighter radius-2 text-300 flex align-center"
      [ngClass]="{ 'search__open-search':searchToogle, 'search__close-search':closeSearch }"
      (click)="showSearchOptions = !showSearchOptions"
    >
      <app-icon
        name="close"
        type="MaterialDesign"
        *ngIf="searchToogle"
        class="search__icon cursor-pointer crucial-text clickable icon icon--small text-primary"
        (click)="clear() "
      ></app-icon>

      <input class="" type="text" placeholder="{{ 'Placeholder.Search' | translate }} " [formControl]="searchControl"/>

      <app-icon
        class="d-inline align-center icon icon--xsmall ml-md-3"
        [ngClass]="{ 'mr-3' : searchToogle, 'text-primary': searchToogle , 'text-primary-200':searchToogle} "
        name="search"
        size="xs"
      ></app-icon>
    </div>

    <div class="search__options pos-absolute bg-white" *ngIf="showSearchOptions">
      <p class="crucial-text px-3 my-1">{{ "Placeholder.SearchFor" | translate }}</p>

      <div class="px-2 my-1">
        <mat-divider class="pos-static"></mat-divider>
      </div>

      <ul class="search__options-list m-0 p-0" *ngFor="let category of SearchCategory | enumToArray">
        <li class="search__option py-2 px-3 cursor-pointer crucial-text" (click)="searchByCategory(category.value) ">
          {{ "layout." + category.value | translate }}
        </li>
      </ul>
    </div>

    <div class="search__options pos-absolute bg-white" [hidden]="!showSearchResult">
      <div class="scrollable scrollable--y bg-white py-0 px-4 search__options-items" #scrollElement>
        <ul class="search__options-list m-0 p-0" *ngFor="let entity of entities; last as isLast ">
          <li class="search__option py-2 px-3 cursor-pointer crucial-text" (click)="navigateToDetailsPage(entity.id) ">
            {{ entity.value | translate }}
          </li>
          <div class="px-2 my-1" *ngIf="!isLast ">
            <mat-divider class="pos-static"></mat-divider>
          </div>
        </ul>

        <div class="pb-2" #loadMoreTrigger>
          <div class="flex align-center justify-center" *ngIf="loading ">
            <app-spinner [small]="true "></app-spinner>
          </div>
          <div class="flex align-center text-600 weight-semibold pb-1 pt-6" *ngIf="endOfResult">
            <small class="px-3">{{'General.noMoreResult' | translate}}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-state-section>
